export default __webpack_public_path__ + "static/media/close-circle.29f7c1f6.svg";